import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import comingSoonIllustration from '../assets/surveys-coming-soon-illustration.png'
import {
  homeSurveysEmptyIllustrationSx,
  homeSurveysEmptySubtitleSx,
  homeSurveysEmptyTitleSx,
  homeSurveysEmptyWrapSx,
} from '../styles/homeStyles'

export const HOME_SURVEYS_EMPTY_TITLE = 'More surveys coming soon'
export const HOME_SURVEYS_EMPTY_SUBTITLE =
  'New surveys will appear here as soon as they are ready. Check back shortly.'

export function SurveysComingSoonEmptyState() {
  return (
    <Box sx={homeSurveysEmptyWrapSx} data-testid="home-surveys-empty" role="status">
      <Box
        component="img"
        src={comingSoonIllustration}
        alt=""
        sx={homeSurveysEmptyIllustrationSx}
        data-testid="home-surveys-empty-illustration"
      />
      <Typography component="p" sx={homeSurveysEmptyTitleSx}>
        {HOME_SURVEYS_EMPTY_TITLE}
      </Typography>
      <Typography component="p" sx={homeSurveysEmptySubtitleSx}>
        {HOME_SURVEYS_EMPTY_SUBTITLE}
      </Typography>
    </Box>
  )
}
